import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/pro-light-svg-icons';
import IconStageCapacity from 'shared/statics/svg/icon_stage_capacity-development.svg?react';
import IconStageReach from 'shared/statics/svg/icon_stage_reach.svg?react';
import IconStageLearn from 'shared/statics/svg/icon_stage_learn.svg?react';
import IconStageAct from 'shared/statics/svg/icon_stage_act.svg?react';
import IconStageSucceed from 'shared/statics/svg/icon_stage_succeed.svg?react';
import IndicatorItem from './Components/IndicatorItem';
import styles from './IndicatorsForecastSummaryTable.module.scss';

const IndicatorsForecastSummaryTable = ({
  stageName,
  indicators,
  handleSaveOrUpdate,
  beneficiary,
  updatingIndicatorId,
}) => {
  return (
    <Fragment>
      <section className={styles.table}>
        {/* <div className={styles.table__header}>
        <span className={styles.heading__label}>Stage</span>
        <span className={styles.heading__label}>Indicator</span>
      </div> */}
        <div className={styles.table__content}>
          <div className={styles.content__row}>
            <div className={styles.stage__container}>
              <span className={`heading-label ${styles.heading__label}`}>
                Stage
              </span>
              <span className={styles.icon__container}>
                {/* <FontAwesomeIcon icon={iconName} /> */}
                {stageName === 'Capacity Development' ? (
                  <IconStageCapacity />
                ) : stageName === 'Reach' ? (
                  <IconStageReach />
                ) : stageName === 'Learn' ? (
                  <IconStageLearn />
                ) : stageName === 'Act' ? (
                  <IconStageAct />
                ) : stageName === 'Succeed (Social Impact)' ? (
                  <IconStageSucceed />
                ) : (
                  ''
                )}
              </span>
              <span className={`heading ${styles.card__heading}`}>
                {stageName}
              </span>
              {/* NOTE: Remove next icon for succeed stage */}
              <span className={styles.next_icon}>
                {stageName !== 'Succeed (Social Impact)' ? (
                  <FontAwesomeIcon icon={faArrowDown} />
                ) : (
                  ''
                )}
              </span>
            </div>
            {/* <IndicatorItem 
            IndicatorName="Gain skills/resources"
          /> */}
            <div className={styles.indicator__wrapper}>
              {(!indicators || indicators?.length === 0) && (
                <span>
                  No indicators are set on this stage. You can complete new
                  indicators on your Impact Model Builder
                </span>
              )}
              {indicators.map(indicator => (
                <IndicatorItem
                  id={indicator.dbId}
                  resultId={indicator.resultId}
                  indicatorName={indicator.name}
                  indicatorForecast={indicator.forecast}
                  indicatorDefinition={indicator.definition}
                  handleSaveOrUpdate={handleSaveOrUpdate}
                  beneficiary={beneficiary}
                  isLoading={indicator.dbId === updatingIndicatorId}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default IndicatorsForecastSummaryTable;
